import type { AccountKey } from "owa-client-types";

export const LOG_DATAPOINT_OBSERVATION_TIMEOUT = 120000;

export interface EcsConfigStateMapping {
    readonly etag: string;
    readonly configIds: string;
}

export interface EcsRolloutConfig {
    readonly EcsRolloutIds?: string;
    readonly EcsConfigAliases?: string;
    readonly EcsPairedStages?: string;
}

export interface EcsConfigStateSnapshot extends EcsConfigStateMapping {
    readonly accountKey: AccountKey;
    readonly lifetimeId: number;
    readonly rolloutConfig?: EcsRolloutConfig;
}

// Observation tickets stay in the local logging/worker envelope, never in telemetry properties.
export interface LogDatapointObservation {
    readonly id: number;
    readonly createdAt: number;
    readonly deadline: number;
    readonly mapping: EcsConfigStateSnapshot;
}

export type LogDatapointOutcome = "sdk-reported-sent" | "discarded" | "suppressed" | "offline" | "failed" | "timeout" | "unsupported" | "cancelled";

export interface LogDatapointObserver {
    readonly observation: LogDatapointObservation;
    isActive(): boolean;
    claimDispatch(): boolean;
    settle(outcome: LogDatapointOutcome): void;
    addCleanup(cleanup: () => void): void;
}

export interface PendingLogDatapointOutcome {
    readonly observation: LogDatapointObservation;
    readonly result: Promise<LogDatapointOutcome>;
    cancel(outcome?: "cancelled" | "timeout"): void;
}

export interface LogDatapointOutcomeMessage {
    readonly action: "LOG_DATAPOINT_OUTCOME";
    readonly generation: number;
    readonly id: number;
    readonly outcome: LogDatapointOutcome;
}

export interface CancelLogDatapointObservationMessage {
    readonly action: "CANCEL_LOG_DATAPOINT_OBSERVATION";
    readonly generation: number;
    readonly observation: LogDatapointObservation;
}

export interface EcsConfigStateSdkSnapshot {
    readonly id: number;
    readonly mapping: EcsConfigStateSnapshot;
}

export type EcsConfigStateSnapshotReporter = (snapshots: readonly EcsConfigStateSdkSnapshot[], revision: number) => Promise<void>;
